import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { obterDetalhamentoPedido } from '../../redux/actions/PedidoAction';
import { MenuEnum, StatusPedidoEnum, PaginaEnum } from '../../enums';
import LogService from '../../services/LogService';
import DialogContext from '../../providers/dialog/DialogContext';
import { StepperHorizontalDetalhamentoPedido } from '../../presentations/web';
import { StepperVerticalDetalhamentoPedido } from '../../presentations/mobile';

import {
    Loading,
    CardErro,
    IconeStatusPedido,
    Header,
    Body
} from '../../presentations';

import {
    makeStyles,
    useMediaQuery,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Divider,
    Grid,
    Typography
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        minWidth: 30
    },
    gutters: {
        padding: 0,
        paddingBottom: 10
    },
    icone: {
        color: theme.palette.primary[200]
    },
    titulo: {
        color: theme.palette.text.disabled
    },
    texto: {
        color: theme.palette.text.primary
    },
    gridModelo: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    gridPlaca: {
        [theme.breakpoints.down('xs')]: {
            marginTop: theme.spacing(2)
        }
    },
    divider: {
        marginBottom: theme.spacing(2)
    }
}));

function DetalhamentoPedidoPage(
    {
        match,
        obterDetalhamentoPedido,
        detalhamento_pedido_loading,
        detalhamento_pedido,
        detalhamento_pedido_erro
    }
) {
    const classes = useStyles();
    const mobile = useMediaQuery(theme => theme.breakpoints.down('xs'));
    const dialog = useContext(DialogContext);
    const {
        contrato,
        pedido,
        item,
        sequencia
    } = match.params;

    useEffect(() => {
        obterDetalhamentoPedido(contrato, pedido, item, sequencia);
    }, [contrato, pedido, item, sequencia, obterDetalhamentoPedido]);

    const handleClickOpenInfo = (codigoStatus) => {
        const titulo = StatusPedidoEnum.properties[codigoStatus].status;
        const texto = StatusPedidoEnum.properties[codigoStatus].mensagem;

        dialog.show(
            titulo,
            texto,
            () => { LogService.registrarAcesso(PaginaEnum.MEUS_CARROS, PaginaEnum.properties[PaginaEnum.MEUS_CARROS].informacao) }
        );
    }

    return (
        <>
            <Header titulo='Detalhes'
                link={MenuEnum.properties[MenuEnum.MEUS_CARROS].path} />
            <Body>
                {
                    (() => {
                        if (detalhamento_pedido_loading === null ||
                            detalhamento_pedido_loading === true)
                            return <Loading />

                        if (detalhamento_pedido_erro !== null)
                            return <CardErro />

                        return <>
                            <List>
                                <ListItem classes={{ gutters: classes.gutters }}>
                                    <ListItemIcon classes={{ root: classes.root }}>
                                        <IconeStatusPedido className={classes.icone} codigoStatus={detalhamento_pedido.codigoStatus} />
                                    </ListItemIcon>
                                    <ListItemText>
                                        <Typography variant='caption'
                                            className={classes.titulo}>
                                            {detalhamento_pedido.descricaoStatus}
                                        </Typography>
                                    </ListItemText>
                                </ListItem>
                                <Divider className={classes.divider} />
                            </List>
                            <Grid container>
                                <Grid item
                                    xs={12}
                                    sm={6}>
                                    <Typography variant='caption'
                                        className={classes.titulo}>
                                        Usuário
                                    </Typography>
                                    <Typography variant='body1'
                                        className={classes.texto}>
                                        {detalhamento_pedido.usuarioVeiculo.usuario}
                                    </Typography>
                                </Grid>
                                {
                                    detalhamento_pedido.usuarioVeiculo.placa &&
                                    <Grid item
                                        className={classes.gridPlaca}
                                        xs={12}
                                        sm={6}>
                                        <Typography variant='caption'
                                            className={classes.titulo}>
                                            Placa
                                        </Typography>
                                        <Typography variant='body1'
                                            className={classes.texto}>
                                            {detalhamento_pedido.usuarioVeiculo.placa}
                                        </Typography>
                                    </Grid>
                                }
                                <Grid item
                                    className={classes.gridModelo}
                                    sm={12}>
                                    <Typography variant='caption'
                                        className={classes.titulo}>
                                        Modelo
                                    </Typography>
                                    <Typography variant='body1'
                                        className={classes.texto}>
                                        {detalhamento_pedido.usuarioVeiculo.modelo}
                                    </Typography>
                                </Grid>
                            </Grid>
                            {
                                (() => {
                                    if (mobile)
                                        return <StepperVerticalDetalhamentoPedido lista={detalhamento_pedido.historico}
                                            handleClickOpenInfo={handleClickOpenInfo} />

                                    return <StepperHorizontalDetalhamentoPedido lista={detalhamento_pedido.historico}
                                        handleClickOpenInfo={handleClickOpenInfo} />
                                })()
                            }
                        </>
                    })()
                }
            </Body>
        </>
    );
}

const mapStateToProps = (state) => ({
    detalhamento_pedido_loading: state.pedido.detalhamento_pedido_loading,
    detalhamento_pedido: state.pedido.detalhamento_pedido,
    detalhamento_pedido_erro: state.pedido.detalhamento_pedido_erro
});

const mapDispatchToProps = {
    obterDetalhamentoPedido
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DetalhamentoPedidoPage));